// extracted by mini-css-extract-plugin
export default {"item":"TotalCharges_item__2u0rt","label":"TotalCharges_label__WZ-1s","sum":"TotalCharges_sum__FeYtR"};